import SwiperElement from "../../molecules/SwiperElement";
import ContainerHead from "../../molecules/ContainerHead";

class RedesignFlashSaleSwiper {
  // Connox Deals Swiper Parameters
  private static swiperParams = {
    navigation: {
      nextEl: ".section-flash-sale .swiper-btn-next",
      prevEl: ".section-flash-sale .swiper-btn-prev",
    },
    pagination: {
      clickable: true,
      el: ".swiper-custom-pagination",
      type: "bullets",
    },
    loop: true,
    updateOnWindowResize: true,
    preloadImages: false,
    speed: 600,
    centeredSlides: true,
    slidesPerView: 1.15,
    allowSlideNext: 2,
    allowSlidePrev: 2,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    spaceBetween: 0,
    effect: "coverflow",
    coverflowEffect: {
      depth: 160,
      rotate: 0,
      slideShadows: false,
      stretch: -36,
    },
    breakpoints: {
      376: {
        slidesPerView: 1.25,
        coverflowEffect: {
          stretch: -40,
        },
      },
      481: {
        slidesPerView: 1.5,
        coverflowEffect: {
          stretch: -42,
        },
      },
      651: {
        slidesPerView: 2,
        coverflowEffect: {
          stretch: -42,
        },
      },
      768: {
        slidesPerView: 1.5,
        coverflowEffect: {
          depth: 220,
          stretch: -62,
        },
      },
      851: {
        slidesPerView: 1.8,
        coverflowEffect: {
          depth: 220,
          stretch: -62,
        },
      },
      941: {
        slidesPerView: 2,
        coverflowEffect: {
          depth: 220,
          stretch: -64,
        },
      },
      1100: {
        slidesPerView: 2,
        coverflowEffect: {
          depth: 220,
          stretch: -68,
        },
      },
    },
  };
  // different swiper settings if there are only two Connox Deals
  private static twoSlidesParams = {
    navigation: false,
    pagination: false,
    slidesPerView: 2,
    spaceBetween: 16,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    slideActiveClass: "section-flash-sale__twoslides",
    slideNextClass: "section-flash-sale__twoslides",
    slidePrevClass: "section-flash-sale__twoslides",
    breakpoints: {
      0: {
        slidesPerView: 1.15,
      },
      481: {
        slidesPerView: 1.5,
      },
      851: {
        slidesPerView: 1.66,
      },
      941: {
        slidesPerView: 2,
      },
    },
  };
  // different swiper settings if there is only one Connox Deal
  private static singleSlideParams = {
    navigation: false,
    pagination: false,
    slidesPerView: 1,
    spaceBetween: 0,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    slideActiveClass: "section-flash-sale__singleslide",
  };

  public static run(section: HTMLElement): void {
    const containerHead: HTMLElement | null = section.querySelector(".react-container-head");
    if (containerHead) {
      new ContainerHead(containerHead);
    }

    const slides = section.querySelectorAll<HTMLElement>("swiper-container swiper-slide");

    if (slides.length >= 3) {
      const navigationButtons: HTMLElement | null = section.querySelector(".swiper-navigation");
      if (navigationButtons !== null) {
        navigationButtons.style.display = "";
      }

      SwiperElement.run(section, RedesignFlashSaleSwiper.swiperParams);
    } else if (slides.length === 2) {
      SwiperElement.run(section, RedesignFlashSaleSwiper.twoSlidesParams);
    } else {
      SwiperElement.run(section, RedesignFlashSaleSwiper.singleSlideParams);
    }
  }
}
export default RedesignFlashSaleSwiper;
